import { z } from "zod";

const MonthResponseDataSchema = z.object({
    month: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
    source: z.string(),
    name: z.string(),
    total_booking: z.number(),
});

export const MonthResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(MonthResponseDataSchema)
});

export type MonthResponse = z.infer<typeof MonthResponseSchema>;
export type MonthResponseData = z.infer<typeof MonthResponseDataSchema>;